import axios from "axios";
// import api url from .env file REACT_APP_API_BASE_URL=https://admin.divinesoftwares.com.au
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const registerCompany = async (companyData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/admin/create-Company`, companyData);
    return response.data;
  } catch (error) {
    console.error("Error registering company:", error);
    throw error;
  }
}